import http from "@/services/http";

/**
 * Insights clínicos do paciente (Salvia Agêntico — Fase 1).
 *
 * O backend (`patient_insights`) é a fonte de verdade: gatilhos reativos
 * (Observers em Exam/BodyComposition/PatientMedication/Prescription/Appointment)
 * geram insights via `InsightService::record`. Este serviço só lê o painel e
 * move o status de um insight (visto/descartado/tratado).
 */

/**
 * Lista os insights de um paciente. Por padrão o backend já exclui os
 * descartados (status != dismissed); passe `status` para filtrar um estado
 * específico.
 *
 * @param {number|string} patientId
 * @param {string|null} status  seen|dismissed|acted|new (opcional)
 * @returns {Promise<object[]>} lista de insights
 *   (`{ id, type, severity, title, body, payload, status, source_type, source_id, created_at }`)
 */
export async function getInsightsByPatient(patientId, status = null) {
  const { data } = await http.get(
    `/api/patient-insights/get-by-patient/${patientId}`,
    { params: status ? { status } : {} },
  );
  return Array.isArray(data?.data) ? data.data : [];
}

/**
 * Move o status de um insight. Só o médico dono do insight pode alterá-lo
 * (o backend responde 404 caso contrário).
 *
 * @param {number} id
 * @param {"seen"|"dismissed"|"acted"} status
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function updateInsightStatus(id, status) {
  return http.patch(`/api/insights/${id}`, { status });
}
